import md from 'markdown-it';
import Image from 'next/image'


export const CoverImage = ({imagePath}: any) => {
  return (
    <div className='max-w-[64ch] w-full text-center mx-auto'>
      <Image src={imagePath} alt="Omnibus cover image" layout="intrinsic" quality={90} width={1920} height={2396} />
    </div>)
}